import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Textarea from 'react-textarea-autosize';
import { InputIconContainer, InputWithIcon, Icon, TextareaStyled, Help, InputStyled, InputContainer, Main } from './InputStyledComponents';
import { MaybeLabel } from '../..';

var Input =
/*#__PURE__*/
function (_Component) {
  _inherits(Input, _Component);

  function Input() {
    _classCallCheck(this, Input);

    return _possibleConstructorReturn(this, _getPrototypeOf(Input).apply(this, arguments));
  }

  _createClass(Input, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          error = _this$props.error,
          valid = _this$props.valid,
          label = _this$props.label,
          help = _this$props.help,
          type = _this$props.type,
          rest = _objectWithoutProperties(_this$props, ["error", "valid", "label", "help", "type"]);

      return React.createElement(InputContainer, null, help && React.createElement(Help, {
        label: label
      }, help), React.createElement(Main, {
        error: error,
        valid: valid,
        inputType: type
      }, React.createElement(MaybeLabel, {
        label: label,
        error: !!error
      }, Input.renderInput(rest))));
    }
  }], [{
    key: "inputWithIcon",
    value: function inputWithIcon(icon, props) {
      return React.createElement(InputIconContainer, null, React.createElement(InputWithIcon, props), React.createElement(Icon, null, icon));
    }
  }, {
    key: "input",
    value: function input(props) {
      return React.createElement(InputStyled, props);
    }
  }, {
    key: "textarea",
    value: function textarea(_ref) {
      var theme = _ref.theme,
          props = _objectWithoutProperties(_ref, ["theme"]);

      return React.createElement(TextareaStyled, {
        theme: theme
      }, React.createElement(Textarea, _extends({
        rows: 1
      }, props)));
    }
  }, {
    key: "renderInput",
    value: function renderInput(props) {
      var textarea = props.textarea,
          icon = props.icon,
          rest = _objectWithoutProperties(props, ["textarea", "icon"]);

      if (textarea) return Input.textarea(rest);
      if (icon) return Input.inputWithIcon(icon, rest);
      return Input.input(rest);
    }
  }]);

  return Input;
}(Component);

_defineProperty(Input, "propTypes", {
  id: PropTypes.string,
  error: PropTypes.string,
  help: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  textarea: PropTypes.bool,
  type: PropTypes.string,
  valid: PropTypes.bool,
  value: PropTypes.string,
  theme: PropTypes.oneOf(['dark', 'light']),
  icon: PropTypes.element
});

_defineProperty(Input, "defaultProps", {
  error: null,
  help: null,
  id: null,
  label: null,
  onChange: null,
  textarea: false,
  type: 'text',
  valid: null,
  value: undefined,
  theme: null,
  icon: null
});

export { Input as default };